import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createSuper.js";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Caip10Link_1;
import { Stream, StreamStatic, SyncOptions } from '@ceramicnetwork/common';
import { StreamRef } from '@ceramicnetwork/streamid';
import { parse } from 'did-resolver';
import { normalizeAccountId } from '@ceramicnetwork/common';
var throwReadOnlyError = function throwReadOnlyError() {
  throw new Error('Historical stream commits cannot be modified. Load the stream without specifying a commit to make updates.');
};
var DEFAULT_CREATE_OPTS = {
  anchor: false,
  publish: true,
  pin: true,
  sync: SyncOptions.PREFER_CACHE
};
var DEFAULT_UPDATE_OPTS = {
  anchor: true,
  publish: true,
  throwOnInvalidCommit: true
};
var DEFAULT_LOAD_OPTS = {
  sync: SyncOptions.PREFER_CACHE
};
var Caip10Link = Caip10Link_1 = /*#__PURE__*/function (_Stream) {
  _inherits(Caip10Link, _Stream);
  var _super = _createSuper(Caip10Link);
  function Caip10Link() {
    var _this;
    _classCallCheck(this, Caip10Link);
    _this = _super.apply(this, arguments);
    _this._isReadOnly = false;
    return _this;
  }
  _createClass(Caip10Link, [{
    key: "did",
    get: function get() {
      return this.content;
    }
  }, {
    key: "setDid",
    value: function () {
      var _setDid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(did, authProvider) {
        var opts,
          didStr,
          parsedDid,
          linkProof,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              opts = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              opts = _objectSpread(_objectSpread({}, DEFAULT_UPDATE_OPTS), opts);
              didStr = typeof did == 'string' ? did.trim() : did.id;
              parsedDid = parse(didStr);
              if (!((parsedDid === null || parsedDid === void 0 ? void 0 : parsedDid.did) !== didStr)) {
                _context.next = 6;
                break;
              }
              throw new Error("DID is not valid: '".concat(didStr, "'"));
            case 6:
              _context.next = 8;
              return authProvider.createLink(didStr);
            case 8:
              linkProof = _context.sent;
              return _context.abrupt("return", this.setDidProof(linkProof, opts));
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function setDid(_x, _x2) {
        return _setDid.apply(this, arguments);
      }
      return setDid;
    }()
  }, {
    key: "setDidProof",
    value: function () {
      var _setDidProof = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(proof) {
        var opts,
          commit,
          updated,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              opts = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
              opts = _objectSpread(_objectSpread({}, DEFAULT_UPDATE_OPTS), opts);
              commit = this.makeCommit(proof);
              _context2.next = 5;
              return this.api.applyCommit(this.id, commit, opts);
            case 5:
              updated = _context2.sent;
              this.state$.next(updated.state);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function setDidProof(_x3) {
        return _setDidProof.apply(this, arguments);
      }
      return setDidProof;
    }()
  }, {
    key: "clearDid",
    value: function () {
      var _clearDid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(authProvider) {
        var opts,
          linkProof,
          _args3 = arguments;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              opts = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
              opts = _objectSpread(_objectSpread({}, DEFAULT_UPDATE_OPTS), opts);
              _context3.next = 4;
              return authProvider.createLink('');
            case 4:
              linkProof = _context3.sent;
              return _context3.abrupt("return", this.setDidProof(linkProof, opts));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function clearDid(_x4) {
        return _clearDid.apply(this, arguments);
      }
      return clearDid;
    }()
  }, {
    key: "makeCommit",
    value: function makeCommit(proof) {
      return {
        data: proof,
        prev: this.tip,
        id: this.state$.id.cid
      };
    }
  }, {
    key: "makeReadOnly",
    value: function makeReadOnly() {
      this.setDidProof = throwReadOnlyError;
      this.setDid = throwReadOnlyError;
      this.sync = throwReadOnlyError;
      this._isReadOnly = true;
    }
  }, {
    key: "isReadOnly",
    get: function get() {
      return this._isReadOnly;
    }
  }], [{
    key: "fromAccount",
    value: function () {
      var _fromAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(ceramic, accountId) {
        var opts,
          normalizedAccountId,
          genesisCommit,
          _args4 = arguments;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              opts = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
              opts = _objectSpread(_objectSpread({}, DEFAULT_CREATE_OPTS), opts);
              normalizedAccountId = normalizeAccountId(accountId);
              genesisCommit = Caip10Link_1.makeGenesis(normalizedAccountId);
              return _context4.abrupt("return", Caip10Link_1.fromGenesis(ceramic, genesisCommit, opts));
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function fromAccount(_x5, _x6) {
        return _fromAccount.apply(this, arguments);
      }
      return fromAccount;
    }()
  }, {
    key: "fromGenesis",
    value: function () {
      var _fromGenesis = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(ceramic, genesisCommit) {
        var opts,
          _args5 = arguments;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              opts = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
              opts = _objectSpread(_objectSpread({}, DEFAULT_CREATE_OPTS), opts);
              return _context5.abrupt("return", ceramic.createStreamFromGenesis(Caip10Link_1.STREAM_TYPE_ID, genesisCommit, opts));
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function fromGenesis(_x7, _x8) {
        return _fromGenesis.apply(this, arguments);
      }
      return fromGenesis;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(ceramic, streamId) {
        var opts,
          streamRef,
          _args6 = arguments;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              opts = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
              opts = _objectSpread(_objectSpread({}, DEFAULT_LOAD_OPTS), opts);
              streamRef = StreamRef.from(streamId);
              if (!(streamRef.type != Caip10Link_1.STREAM_TYPE_ID)) {
                _context6.next = 5;
                break;
              }
              throw new Error("StreamID ".concat(streamRef.toString(), " does not refer to a '").concat(Caip10Link_1.STREAM_TYPE_NAME, "' stream, but to a ").concat(streamRef.typeName));
            case 5:
              return _context6.abrupt("return", ceramic.loadStream(streamRef, opts));
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function load(_x9, _x10) {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "makeGenesis",
    value: function makeGenesis(accountId) {
      if (accountId.chainId.namespace === 'eip155') {
        accountId.address = accountId.address.toLowerCase();
      }
      var legacyAccountId = "".concat(accountId.address, "@").concat(accountId.chainId.toString());
      return {
        header: {
          controllers: [legacyAccountId],
          family: "caip10-".concat(accountId.chainId.toString())
        }
      };
    }
  }]);
  return Caip10Link;
}(Stream);
Caip10Link.STREAM_TYPE_NAME = 'caip10-link';
Caip10Link.STREAM_TYPE_ID = 1;
Caip10Link = Caip10Link_1 = __decorate([StreamStatic()], Caip10Link);
export { Caip10Link };